import PlaidBaseComponent from 'javascripts/components/PlaidBaseComponent';
import React from 'react';
import store from 'javascripts/store.js';

class DonateFormPlaidComponent extends React.Component {
  onSuccess = (publicToken, metadata) => {
    store.donateForm.last4 = metadata.account.mask;
    store.donateForm.plaidAccountId = metadata.account.id;
    store.donateForm.plaidToken = publicToken;

    store.donateForm.createDonationForm('ach', (response) => {
      if (store.bps.hasRecipients) {
        store.bps.paymentMethod = 'plaid';
        store.bps.bankName = metadata.institution.name;

        if(store.donateForm.managementMode) {
          window.location = response.redirectUrl;
        }
      } else {
        window.location = response.redirectUrl;
      }
    });
  };

  render () {
    const {
      plaidKey,
      onSubmitClick,
    } = this.props;

    const { plaidEnv } = store.donateForm;

    return (
      <span
        className="ach-base-component"
        ref={el => this.plaidComponentWrapper = el}
      >
        <PlaidBaseComponent
          checkForExistingMembership={!store.donateForm.disableMembershipCheck}
          onSubmitClick={onSubmitClick}
          onSuccess={this.onSuccess}
          plaidEnv={plaidEnv}
          plaidKey={plaidKey}
        >
          {this.props.children}
        </PlaidBaseComponent>
      </span>
    );
  }
}

export default DonateFormPlaidComponent;
